export const OptionsAlert = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  className: "flex justify-center items-center w-full",
};

export const OptionsSweetAlert = {
  title: "Estás seguro/a?",
  text: "¡No podrás revertir esto!",
  icon: "question",
  showCancelButton: true,
  cancelButtonColor: "#d33",
  confirmButtonColor: "#16A34A",
  cancelButtonText: "VOLVER",
  confirmButtonText: "VOTAR",
};
